import { withInstall } from '@sgui-plus/utils/with-install'

import Popconfirm from './src/popconfirm.vue'

export const SgPopconfirm = withInstall(Popconfirm)
export default SgPopconfirm

export * from './src/popconfirm'
